import { render, staticRenderFns } from "./cta-comment.vue?vue&type=template&id=42925b2d&scoped=true"
import script from "./cta-comment.vue?vue&type=script&lang=js"
export * from "./cta-comment.vue?vue&type=script&lang=js"
import style0 from "./cta-comment.vue?vue&type=style&index=0&id=42925b2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42925b2d",
  null
  
)

/* custom blocks */
import block0 from "./cta-comment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports